import React, { useEffect, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { getBoardsForInvestor } from '../../../services/analysisContentService';

import { RootState } from '../../../../redux/store';
import { POPUP } from '../../../../redux/types';

import { IBoardDataObject } from '../../../../models/types/IBoardDataObject';

import BoardsTabs from '../../components/boardsTabs/boardsTabs';
import ComponentLoader from '../../../ui/loaders/componentLoader/componentLoader';

const InvestorBoardsContainer: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [boards, setBoards] = useState<IBoardDataObject[]>([]);
  const [noBoards, setNoBoards] = useState<boolean>(false);

  const { t } = useTranslate();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const previouslySelectedBoard = useSelector((state: RootState) => state.board.activeBoard);

  useEffect(() => {
    let isMounted = true;
    setNoBoards(false);
    if (params.investorId) {
      getBoardsForInvestor(params.investorId)
        .then((boards) => {
          if (isMounted) {
            setBoards(boards);
            if (boards.length === 0) setNoBoards(true);
            setLoading(false);
            if (!params.boardId && boards.length > 0) {
              let boardToRedirectTo = boards.find((board) => board.id === previouslySelectedBoard);
              if (!boardToRedirectTo) boardToRedirectTo = boards[0];
              navigate(`/boards/${params.investorId}/${boardToRedirectTo.id}`, { replace: true });
            }
          }
        })
        .catch((err) => {
          dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message });
          setLoading(false);
        });
    }

    return () => {
      isMounted = false;
      setBoards([]);
      setLoading(true);
    };
  }, [params.investorId]);

  if (loading) return <ComponentLoader />;
  if (noBoards) {
    return (
      <div className='no-boards-message-wrapper'>
        <p>{t('BOARDS.NO_BOARDS')}</p>
      </div>
    );
  }

  return (
    <>
      <BoardsTabs boards={boards} />
      <Outlet context={boards}/>
    </>
  );
};
export default InvestorBoardsContainer;
